import { createTheme } from "@mui/material";

const lightTheme = createTheme({
    palette: {
        mode: "light"
    }
});

export default lightTheme;